import InputField from 'components/coaches-builder/InputField/InputField';

export default InputField;
